import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    borderRadius: 8,
    marginTop: 8,
    border: `1px solid ${theme.palette.grey[300]}`
  },
  adminRoot: { opacity: '50%' },
  sectionTitle: {
    fontSize: 16,
    fontWeight: 600,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
      fontWeight: 600
    },
    color: theme.palette.text.primary
  },
  roomBlock: {
    marginBottom: theme.spacing(3)
  },

  icon: { fontSize: 20, color: theme.palette.text.primary },
  verticalAlign: {
    fontWeight: 500,
    fontSize: '1rem',
    display: 'flex',
    verticalAlign: 'middle'
  },
  profileIcon: {
    fontSize: 20,
    [theme.breakpoints.down('sm')]: {
      fontSize: 18
    },
    color: theme.palette.grey[700],
    marginRight: 4
  },
  greyText: { fontWeight: 500, color: theme.palette.grey[700] },
  blackText: { fontWeight: 500, color: theme.palette.text.primary },
  personCard: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: 6,
    paddingRight: 6,
    backgroundColor: theme.palette.grey[200],
    [theme.breakpoints.up('sm')]: {
      height: 76
    }
  },
  iconBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      minWidth: 200
    },
    borderRight: `1px solid ${theme.palette.grey[300]}`
  },
  iconText: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    marginBottom: 6,
    flexWrap: 'wrap'
  },
  detailsBox: {
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1)
  },

  header: { padding: theme.spacing(2) },
  content: { padding: theme.spacing(2) },
  row: { display: 'flex', alignItems: 'center', marginRight: 16 },
  formIcon: {
    color: theme.palette.grey[500],
    fontSize: 18,
    marginRight: 8,
    alignSelf: 'center'
  }
}))
